module.exports = __webpack_public_path__ + "static/media/157-republic-of-the-congo.5f74c196.svg";